import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

// Mount Severity enum-selector UUIDs (Issues - Mount.txt). Single source of truth for the FE.
export const MOUNT_SEVERITY_HIGH = 'b16c47d3-bbd1-4ec0-803d-dade181f9f8c';
export const MOUNT_SEVERITY_MEDIUM = 'e9f65d84-5026-426a-bb72-9595b8cf9866';

export interface OttoClaimLine {
  lineNumber: string;
  articleNumber: string;
  claimedQuantity: string;
  orderedQuantity: string;
  unit: string;
  reason: string;
}

// Matches the backend OttoCreateClaimRequest.
export interface OttoCreateClaimRequest {
  customerNumber: string;
  customerName: string;
  orderNumber: string;
  invoiceNumber: string;
  userName: string;
  userEmail: string;
  description: string;
  primaryReason: string;
  desiredSolution: string;
  severityId: string;
  lines: OttoClaimLine[];
}

export interface OttoCreateClaimResponse {
  issueId: string;
}

@Injectable({ providedIn: 'root' })
export class OttoOlsenClaimService {
  constructor(private http: HttpClient) {}

  // Multipart: JSON 'claim' part plus optional 'images' file parts.
  createClaim(claim: OttoCreateClaimRequest, images: File[] = []): Observable<OttoCreateClaimResponse> {
    const formData = new FormData();
    formData.append('claim', new Blob([JSON.stringify(claim)], { type: 'application/json' }));
    (images || []).forEach(image => formData.append('images', image, image.name));
    return this.http.post<OttoCreateClaimResponse>('json/otto/claim', formData);
  }
}
